// the saved scatter graphs Alpine object
window.appSavedScatterGraphs = () => {
    return {
        scatterGraphs: [],

        init: function() {
            this.loadScatterGraphs();
        },

        /*
         * Loads in the saved scatter graphs from the API
         */
        loadScatterGraphs: function(id) {
            axios.get('/api/saved-scatter-graphs/')
                .then( response => {
                    this.scatterGraphs = response.data;
                })
                .catch( ajaxFail )
        },

        /*
         * Deletes the selected scatter graph from the frontend scatter graphs list and permentently via the API
         */
        deleteScatterGraph: async function(id) {

            const msg = getLang('confirm_delete_saved_scatter_graph');
            const doDelete = await modalConfirm(msg, 'Delete');

            if( doDelete ) {
                axios.post('/api/saved-scatter-graph/' + id, {'_method' : 'DELETE'})
                    .then( response => {
                        this.scatterGraphs = this.scatterGraphs.filter( v => v.id !== id );
                    })
                    .catch( ajaxFail )
            }
        },
    }
};
